import { render, staticRenderFns } from "./MenuListPermit.vue?vue&type=template&id=06d21ac0&lang=pug&"
import script from "./MenuListPermit.vue?vue&type=script&lang=js&"
export * from "./MenuListPermit.vue?vue&type=script&lang=js&"
import style0 from "./MenuListPermit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports